import { Catalog } from '@df/catalog/catalog.interfaces';
import { BundleSelection } from '@df/catalog/product/bundle-selection';
import { IBuyRequestData } from '@df/session/api/basket/basket';
import { LocalProduct } from '../../../../model/product/product.decorator';
import { IProductDataV3 } from '@df/catalog/product/product';
export namespace NProductBundleOptions {
    export const MODAL_ID = 'product-bundle-options-modal';
    export interface IModalData {
        product: LocalProduct<IProductDataV3>;
        selection: BundleSelection;
        buyRequest?: IBuyRequestData;
        qty?: number;
    }
    export interface IBlockData extends Catalog.IBlockData<IContentData> {}
    export interface IContentData {
        description?: string;
    }
}
